import { createFileRoute } from '@tanstack/react-router';
import ClientPortal from '../../components/portals/ClientPortal';

export const Route = createFileRoute('/client/_layout')({
  component: ClientPortal,
});
